export class FileGetDTO {
  constructor(file) {
    this.id = file.id;
    this.error = file.error || "error desconocido";
    this.url = file.url || null;
    this.date = new Date(file.fecha_procesamiento)
     || null;
  }
}
